"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteItemDiscountAction = void 0;
const react_1 = __importDefault(require("react"));
const IconDelete_1 = require("../../icons/IconDelete");
const DeleteItemDiscountAction = (props) => {
    return (react_1.default.createElement("a", { className: "icon-delete-discount no-print", title: "Rabatt l\u00F6schen", onClick: props.onDelete },
        react_1.default.createElement(IconDelete_1.IconDelete, null)));
};
exports.DeleteItemDiscountAction = DeleteItemDiscountAction;
